import { pageContainerStyles } from "@insite/content-library/Widgets/CheckoutReviewAndSubmit/CheckoutReviewAndSubmitPageContainer";
import merge from "lodash/merge";
import { css } from "styled-components";

merge(pageContainerStyles, {
    hiddenShippingInfoAndProductListWide: {
        below: "lg",
        css: css`
            flex-basis: 100%;
        `,
    },
    hiddenShippingInfoAndProductListNarrow: {
        above: "md",
        css: css`
            flex-basis: 100%;
        `,
    },
});
